import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { FormUtils as GetAllFormFields } from "sz-react-utils";

import StudentInfo from "../../../components/StudentInfo";
import CourseFinder from "../courseFinder";
import ApplicationMailer from "../applicationMailer";
import ApplicationOfferExpected from "../applicationOfferExpected";

import moment from "moment";
import async from "async";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Upload,
  Tooltip,
  Switch,
  Drawer
} from "antd";
import _ from "lodash";
import StudentHeader from "../../../components/studentHeader";
import common from "../../common.less";
import { hideLoader, showLoader } from "../../../modules/actions";

import Request, { API_URL, LAPI_URL } from "../../../request";
import { connect } from "react-redux";
import { getUrlPushWrapper } from "../../../routes";
import styles from "../counselling/add/styles.less";
import Moment from "moment";

import userRights from "../../../components/_utils/userRights";
import { options } from "chrono-node";
import { RightsWrapper } from "../../../components/_utils/utils";
const { TextArea } = Input
const showChannelPartner = userRights.getUserAuth("showChannelPartner");
const pendingConsultancyAlertToAdmissionVisa = userRights.getUserAuth("pendingConsultancyAlertToAdmissionVisa");
const Option = Select.Option;
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const useCountrySpecificStatus = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).useCountrySpecificStatus : false;
const statusList = [
  "Received",
  "Being Reviewed",
  "Pending Documents",
  "Program Closed Application Not Processed",
  "Processed",
  // "Received by University",
  // "Offer Expected on",
  // "Admission Rejected",
  // "Course Waitlisted",
];
const offerStatusList = [
  "Offer Pending",
  "Interview Required",
  "Offer Rejected",
  "Additional Docs Required",
  "Conditional Offer Received",
  "Unconditional Offer Received",
];


@Form.create()
class UpdateCourse extends React.Component {
  state = {
    visible: true,
    intakes: [],
    years: [],
    channelPartners: [],
  }


  loadData = async () => {
    let { cousreId } = this.props;
    let response = await Request.getCourse(cousreId.courseId);
    let { doc: { course } } = response
    let intakes = [];
    async.each(course.intakes, (item) => {
      intakes.push(moment(new Date(item)).format("MMM"))
    })
    let currentYear = new Date().getFullYear();
    // let startYear = currentYear - 5;
    let startYear = currentYear;
    let years = [];
    for (let i = startYear; i <= currentYear + 5; i++) {
      years.push(i)
    }
    let universityChannelPartners = await Request.loadChannelPartnerByPriority({ universityId: cousreId.universityId, courseId: cousreId.courseId });
    // let universityChannelPartners = await Request.loadChannelPartnerByUniversityID({ uniId: cousreId.universityId });
    universityChannelPartners.channelPartners = universityChannelPartners.channelPartners.reduce((temp, vv) => {
      temp.push({
        id: (vv._id && vv._id.$oid) ? vv._id.$oid : vv._id,  // handles both { $oid: ... } and string
        display: `${vv.channelPartnerName}${vv.preferredPartner ? ' -(Preferred)' : ''}`
      });

      return temp; // Ensure temp is returned
    }, []);
    this.setState({ intakes, years, channelPartners: universityChannelPartners.channelPartners })
  }

  setFormValue = () => {
    let { cousreId, form: { setFieldsValue } } = this.props
    setTimeout(() => {
      setFieldsValue({ intake: cousreId.intake ? cousreId.intake : null, intakeYear: cousreId.intakeYear ? cousreId.intakeYear : null, channelPartnerId: cousreId.channelPartnerId ? cousreId.channelPartnerId : null });
    }, 1000);
  }

  componentDidMount() {
    this.loadData();
    this.setFormValue();
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => {
      this.props.onClose();
    }, 500);
  }


  handleSubmit = (e) => {
    e.preventDefault();
    let { form, inquiryId, cousreId } = this.props;
    let { channelPartners } = this.state;
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      _.each(values, (val, key) => {
        cousreId[key] = val;
      });
      if (values.channelPartnerId) {
        let findChannelPartner = channelPartners.find(obj => {
          return obj.id === values.channelPartnerId;
        })
        if (findChannelPartner) {
          cousreId.channelPartnerName = findChannelPartner.display;
        }
      }
      let response = await Request.updateApplicationDeskCourse({ inquiryId, cousreId });
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose();
    })
  }

  render() {
    let { visible } = this.state;
    let { form: { getFieldDecorator, setFieldsValue }, cousreId } = this.props;
    let inputSchema = {
      fields: [
        {
          title: 'Choose Intake',
          key: 'intake',
          type: 'select',
          options: this.state.intakes,
          required: true,
          onChange: (val) => {
            setFieldsValue({ intake: val })
          }
        },
        {
          title: 'Choose Year',
          key: 'intakeYear',
          type: 'select',
          options: this.state.years,
          required: true,
          onChange: (val) => {
            setFieldsValue({ intakeYear: val })
          }
        },
        {
          title: 'Select Channel Partner',
          key: 'channelPartnerId',
          type: 'select',
          options: this.state.channelPartners,
          hidden: !this.state.channelPartners.length,
          onChange: (val) => {
            setFieldsValue({ channelPartnerId: val })
          }
        }
      ]
    }
    return (
      <Drawer title={`Update Course:- ${cousreId.courseName}`} placement="right"
        closable={true}
        width={800}
        onClose={this.onClose}
        visible={visible}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields
              apiurl={LAPI_URL}
              inputSchema={inputSchema}
              getFieldDecorator={getFieldDecorator}
            />
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}



@Form.create()
class AddApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inquiryId: null,
      info: {},
      visible: false,
      mailer: false,
      course: [],
      nextYears: [],
      moveToNextDesk: false,
      choosenCourseId: null,
      files: [],
      countryFieldArr: [],
      processes: {},
      smsCounselor: "Yes",
      aggrementSigned: "Yes",
      displayAggrementSigned: null,
      emailStudent: "Yes",
      smsStudent: "Yes",
      courseStartDate: null,
      feeDueDate: null,
      elicos: null,
      showOfferDateDrawer: false,
      instituteStudentId: null,
      allUsers: [],
      visaUserId: [],
      inquiryInfo: {},
      localUser: {},
      selectedCountryId: [],
      updateCourseDrawer: false,
      updateCourseId: null
    };

    this.mailer = React.createRef();
    this.updateExpDate = React.createRef();
  }

  uploadOffer = (courseId, singleCourse) => {
    if (!singleCourse.uploadStatus) {
      singleCourse.uploadStatus = "Offer Pending";
    }

    if (
      singleCourse.uploadStatus === "Conditional Offer Received" ||
      singleCourse.uploadStatus === "Unconditional Offer Received"
    ) {
      if (!this.state.localUser.isFinance && !this.state.localUser.isAdministrator) {
        if (!this.state.files || !this.state.files.length) {
          return notification.error({ message: "Choose offer file" });
        }
      }
      if (!singleCourse.courseStartDate) {
        return notification.error({
          message: "Please select course start date.",
        });
      }
      if (!singleCourse.feeDueDate) {
        return notification.error({ message: "Please select fee due date." });
      }
      if (!singleCourse.instituteStudentId) {
        return notification.error({
          message: "Please add institute student id.",
        });
      }
    }


    let obj = {
      _id: this.state.inquiryId,
      courseId: courseId,
      files: this.state.files ? this.state.files : [],
      uploadStatus: singleCourse.uploadStatus,
    };
    if (singleCourse.uploadStatus === "Offer Rejected" && !singleCourse.offerRejectionReason) {
      return notification.error({
        message: 'Please Add Offer Rejection Reason'
      })
    }
    if (singleCourse.uploadStatus === "Conditional Offer Received" || singleCourse.uploadStatus === "Additional Docs Required") {
      if (!singleCourse.documentsRequired) {
        return notification.error({
          message: 'Please Add Required Documents List'
        })
      }
      obj.documentsRequired = singleCourse.documentsRequired
    }
    if (
      singleCourse.uploadStatus === "Conditional Offer Received" ||
      singleCourse.uploadStatus === "Unconditional Offer Received"
    ) {
      obj.courseStartDate = singleCourse.courseStartDate;
      obj.feeDueDate = singleCourse.feeDueDate;
      obj.instituteStudentId = singleCourse.instituteStudentId;
    }
    if (singleCourse.uploadStatus === "Interview Required") {
      obj.courseName = singleCourse.courseName;
      obj.interviewDate = singleCourse.interviewDate;
      obj.interviewOutcome = singleCourse.interviewOutcome;
      obj.universityInstitutionName = singleCourse.universityInstitutionName;
    }



    const { dispatch } = this.props;
    dispatch(showLoader());
    Request.uploadOffer(obj)
      .then((resp) => {
        dispatch(hideLoader());
        if (resp.success) {
          this.setFormValues(this.state.inquiryId);
          return notification.success({
            message: "Success",
            description: resp.msg,
          });
        }

        if (resp.error) {
          return notification.error({
            message: "Error",
            description: resp.msg,
          });
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
      });
  };

  handleChangeOfAgent = async ({ checked, courseId, inquiryId }) => {
    let response = await Request.changeOfAgentInAdmission({ changeOfAgent: checked, courseId, inquiryId })
    if (response.success) {
      notification.success({
        message: response.msg
      })
    } else {
      notification.error({
        message: response.msg
      })
    }
    window.location.reload()
  }

  reUploadOffer = (courseId, singleCourse) => {
    let channelPartnerName = "";
    if (singleCourse.channelPartners) {
      for (
        let index = 0;
        index < singleCourse.channelPartners.length;
        index++
      ) {
        const element = singleCourse.channelPartners[index];
        if (element._id === singleCourse.channelPartnerId) {
          channelPartnerName =
            element.channelPartnerName +
            " " +
            (element.preferredPartner ? "(Preferred)" : "");
        }
      }
    }
    let obj = {
      _id: this.state.inquiryId,
      courseId: courseId,
      stage2: singleCourse.stage2,
      stage2Clone: singleCourse.stage2Clone,
      channelPartnerId: singleCourse.channelPartnerId,
      channelPartnerName: channelPartnerName,
    };
    if (this.state.files) {
      obj.files = this.state.files;
    }
    if (
      obj.stage2Clone.offerStatus === "Conditional Offer Received" ||
      obj.stage2Clone.offerStatus === "Unconditional Offer Received"
    ) {
      if (
        (singleCourse && !singleCourse.stage2) ||
        (singleCourse &&
          singleCourse.stage2 &&
          !singleCourse.stage2.offerUpload)
      ) {
        if (!this.state.localUser.isFinance || !this.state.localUser.isAdministrator) {
          if (!obj.files || !obj.files.length) {
            return notification.error({ message: "Choose offer file" });
          }
        }
      }
      if (!obj.stage2Clone.courseStartDate) {
        return notification.error({
          message: "Please select course start date.",
        });
      }
      if (!obj.stage2Clone.feeDueDate) {
        return notification.error({ message: "Please select fee due date." });
      }
      if (!obj.stage2Clone.instituteStudentId) {
        return notification.error({
          message: "Please add institute student id.",
        });
      }
    }
    if (
      obj.stage2Clone.offerStatus !== "Conditional Offer Received" &&
      obj.stage2Clone.offerStatus !== "Unconditional Offer Received"
    ) {
      obj.stage2Clone.courseStartDate = "";
      obj.stage2Clone.feeDueDate = "";
      obj.stage2Clone.elicos = "";
    }

    const { dispatch } = this.props;

    dispatch(showLoader());
    Request.reUploadOffer(obj)
      .then((resp) => {
        dispatch(hideLoader());
        if (resp.success) {
          this.setFormValues(this.state.inquiryId);

          return notification.success({
            message: "Success",
            description: resp.msg,
          });
          // this.loadData()
        }
        if (resp.error) {
          return notification.error({
            message: "Error",
            description: resp.msg,
          });
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
      });
  };

  async getApplicationStatusByCountryId(data) {
    let response = await Request.getStatusByUniversityCountry(data);
    return response
  }
  // applicationStatus[countryid] = 

  closeFollowUp = () => {
    this.setState({ visible: false });
  };

  calback = (val) => {
    let cloneCourse = _.clone(this.state.course);

    let findCourse = _.find(cloneCourse, (item) => {
      return item.courseId === val.courseId;
    });
    if (findCourse) {
      if (val.pathwayName) {
        findCourse.pathwayName = val.pathwayName;
      } else {
        notification.success({
          message: "Success",
          description: "Course already exists.",
        });
      }
    } else {
      if (val && val.intakes) {
        let test = [];
        let year = [];
        _.each(val.intakes, (kl) => {
          kl = moment(new Date(kl)).format("MMM");
          let kp = moment(new Date(kl)).format("YYYY");

          test.push(kl);
          year.push(kp);
        });
        val.intakes = test;
        val.year = year;
      }
      cloneCourse.push(val);
      this.setState({
        course: cloneCourse,
      });
    }
  };

  MailerCallback = () => { };
  closeMailer = () => {
    this.setFormValues(this.state.inquiryId);
    this.setState({ mailer: false });
  };
  showMailer = (item) => {
    this.setState({ choosenCourseId: item.courseId }, () => {
      this.setState({ mailer: true });
    });
  };

  normalizeId(val) {
    if (!val) return null;
    return (val && typeof val === "object" && val.$oid) ? val.$oid : val;
  }


  removeCourse = (item) => {
    let cloneCourse = _.clone(this.state.course);
    cloneCourse = _.reject(cloneCourse, (itemV) => {
      return this.normalizeId(item._id) === (itemV._id);
    });
    this.setState({
      course: cloneCourse,
    });
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
  saveApplicationIntake = async (item) => {
    if (!item.choosenIntake) {
      return notification.error({
        message: "Choose Intake",
      });
    }

    if (
      item.mainCampus &&
      item.mainCampus.length > 0 &&
      item.campusId == null
    ) {
      notification.error({
        message: "Required",
        description: "Choose Campus",
      });
      return;
    }

    if (
      showChannelPartner &&
      item.channelPartners &&
      item.channelPartners.length > 0 &&
      item.channelPartnerId == null
    ) {
      notification.error({
        message: "Required",
        description: "Choose Channel Partner",
      });
      return;
    }

    const { dispatch } = this.props;

    let course = {
      courseId: item.courseId,
      courseName: item.courseName,
      tutionFee: item.tutionFee ? parseInt(item.tutionFee) : 0,
      pathwayId: item.pathwayId,
      pathwayName: item.pathwayName,
      intake: item.choosenIntake,
      intakeYear: item.choosenYear,
      universityId: item.universityId,
      countryId: item.countryId,
      universityInstitutionName: item.universityInstitutionName,
      applicationDate: new Date(),
    };
    if (item.mainCampus && item.mainCampus.length > 0) {
      course["campusId"] = item.campusId;
      course["campusName"] = item.campusName;
    }
    if (item.channelPartners && item.channelPartners.length > 0) {
      course["channelPartnerId"] = item.channelPartnerId;
      course["channelPartnerName"] =
        item.channelPartnerName &&
          Array.isArray(item.channelPartnerName) &&
          item.channelPartnerName.length > 0
          ? item.channelPartnerName.join(" ")
          : item.channelPartnerName;
    }
    let obj = {
      _id: this.normalizeId(this.state.info._id),
      course: course,
    };
    dispatch(showLoader());
    let x = await Request.addApplicationIntake(obj);
    dispatch(hideLoader());
    if (x.success) {
      this.setFormValues(this.state.inquiryId);
      return notification.success({
        message: x.msg,
      });
    } else {
      return notification.error({
        message: x.msg,
      });
    }
  };

  setFormValues = async (inquiryId) => {
    const { form } = this.props;
    try {
      let { doc } = await Request.getInquiry(inquiryId);
      if (doc) {
        this.setState({ visaUserId: doc.visaUserId });
        let docLoaded = _.clone(doc.applicationsDesk);
        let inputTypes = this.state;
        delete docLoaded["course"];
        _.each(docLoaded, (item, key) => {
          inputTypes[key] = item;
          if (key === "aggrementSigned") {
            inputTypes[key] = item === true ? "Yes" : "No";
          }
        });
        this.setState({
          ...inputTypes,
          displayAggrementSigned:
            this.state.aggrementSigned === "No" ? " " : null,
        });

        form.setFieldsValue({
          issueDate: Moment(doc.issueDate),
          expiryDate: Moment(doc.expiryDate),
          issueCountryId: doc.issueCountryId,
          passportNumber: doc && doc.profile ? doc.profile.passportNumber : "",
        });

        _.each(doc.applicationsDesk.course, (val) => {
          val.stage2Clone = _.clone(val.stage2);
        });

        let findIn = _.find(doc.applicationsDesk.course, (val) => {
          if (!val) return false;
          if (val.stage1 && val.stage1.status) {
            val.stage1.applicationStatus = val.stage1.status;
          }

          if (!val.stage2) {
            return false;
          }

          val.uploadStatus = val.stage2.offerStatus;
          val.documentsRequired = val.stage2.documentsRequired

          return (
            val &&
            val.stage2 &&
            (val.stage2.offerStatus === "Conditional Offer Received" ||
              val.stage2.offerStatus === "Unconditional Offer Received") &&
            (doc.atLevel === "Application Desk" ||
              doc.moveType === "Application Desk - partial")
          );
        });

        let { course: applicationCourse = [] } = doc.applicationsDesk;
        this.courseListByIds(applicationCourse);
        this.setState(
          {
            info: doc,
            moveToNextDesk: findIn ? true : false,
            moveType:
              doc.moveType === "Application Desk - partial"
                ? "Partial"
                : "Permanent",
          },
          () => { }
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  saveApplicationStatus = async (item) => {
    let { info, course } = this.state;
    if (!item.stage1.status) {
      return notification.error({
        message: "Choose Status",
      });
    }

    const { dispatch } = this.props;
    if (item.stage1.applicationStatus) {
      item.stage1.status = item.stage1.applicationStatus;
    }

    let found = _.find(info.applicationsDesk.course, (val) => {
      return this.normalizeId(val._id) === this.normalizeId(item._id);
    });
    if (found) {
      if (
        item.stage1.status === "Offer Expected on" &&
        found.stage1.status !== "Processed" &&
        !found.processedDate
      ) {
        _.each(course, (item) => {
          if (this.normalizeId(found._id) === this.normalizeId(item._id)) {
            item.stage1.status = "ooo";
          }
        });

        return notification.error({
          message: "Application Status must be Processed.",
        });
      }
    }

    let obj = {
      _id: this.state.inquiryId,
      courseId: item.courseId,
      stage1: item.stage1,
    };

    dispatch(showLoader());
    let x = await Request.saveApplicationStatus(obj);
    dispatch(hideLoader());
    if (x.success) {
      if (item.stage1.applicationStatus == "Processed" || item.stage1.applicationStatus == "application processed/ submitted" || item.stage1.applicationStatus == "Application Processed/Submitted") {
        await Request.saveApplicationStatus({
          _id: this.state.inquiryId,
          courseId: item.courseId,
          stage1: {
            applicationStatus: "Offer Expected on",
            status: "Offer Expected on"
          }
        });
      }
      this.setFormValues(this.state.inquiryId);
      if (
        item &&
        item.stage1 &&
        (item.stage1.status === "Offer Expected on" ||
          item.stage1.status === "Processed" || item.stage1.status === "application processed/ submitted" || item.stage1.status === "Application Processed/Submitted")
      ) {
        this.setState({ choosenCourseId: item.courseId }, () => {
          this.setState({ mailer: true });
        });
      }
      return notification.success({
        message: x.msg,
      });
    } else {
      return notification.error({
        message: x.msg,
      });
    }
  };
  handleChange = (v) => {
    if (v.fileList) {
      this.setState({ files: v.fileList });
    }
  };
  removeAppCourse = async (courseId) => {
    const { dispatch } = this.props;
    let obj = {
      _id: this.state.inquiryId,
      courseId,
    };
    dispatch(showLoader());
    let response = await Request.removeApplicationCourse(obj);
    dispatch(hideLoader());
    if (response && response.success) {
      notification.success({
        message: "Success",
        description: response.msg,
      });
      this.setFormValues(this.state.inquiryId);
    } else {
      notification.error({
        message: "Error",
        description: "Try again",
      });
    }
  };

  onRemove = (v) => {
    console.log(v);
  };

  getNextFiveYears = () => {
    let currentYear = new Date().getFullYear();
    // let startYear = currentYear - 5;
    let startYear = currentYear;
    let years = [];
    for (let i = startYear; i <= currentYear + 5; i++) {
      years.push(i)
    }
    this.setState({ nextYears: years })
  }

  async componentDidMount() {
    this.loadData();
    this.loadCountries();
    this.getNextFiveYears();
    let localUser = JSON.parse(localStorage.getItem("user"));
    let { data: allUsers } = await Request.loadDeskUser({
      results: 10000,
      isVisa: true,
      active: true,
      // userBranch: localUser ? localUser.userBranch : null,
      userId: this.normalizeId(localUser._id),
    });
    this.setState({ allUsers: allUsers, localUser: localUser });
  }

  closeOfferDrawer = () => {
    this.setState({ showOfferDateDrawer: false }, () => {
      this.loadData();
    });
  };

  async loadData() {
    let searchParams = new URLSearchParams(this.props.search);
    let inquiryId = searchParams.get("id");
    if (inquiryId) {
      let response = await Request.getInquiry(inquiryId)
      this.setState({ inquiryId: inquiryId, inquiryInfo: response.doc });
      this.setFormValues(inquiryId);
    }
  }

  async courseListByIds(data) {
    let selectedCountryId = []
    let ids = [];
    _.each(data, (item) => {
      if (!item.intake) {
        ids.push(item.courseId);
      }
    });
    let resp = await Request.courseListByIds(ids);
    async.each(
      data,
      (item, cb) => {
        selectedCountryId.push(item.countryId)
        if (!item.intake) {
          delete item["stage1"];
          delete item["stage2"];
          delete item["stage3"];
        }
        let findObj = _.find(resp, (item11) => {
          if (item11 && item11.course) {
            return this.normalizeId(item11.course._id) === item.courseId;
          }
        });
        if (findObj) {
          item.intakes = [];
          item.tutionFee = findObj.course.tutionFee
            ? findObj.course.tutionFee.toString()
            : null;
          if (findObj.course && findObj.course.intakes) {
            _.each(findObj.course.intakes, (kl) => {
              kl = moment(new Date(kl)).format("MMM");
              item.intakes.push(kl);
            });
            cb();
          } else {
            cb();
          }
        } else {
          cb();
        }
      },
      () => {
        this.setState({ course: data, selectedCountryId });
      }
    );
  }

  setUploadFields(val, index, field) {
    let cloneCourse = _.clone(this.state.course);
    cloneCourse[index][field] = val;
    this.setState({ course: cloneCourse });
  }

  setApplicationStatus(val, courseId) {
    let cloneCourse = _.clone(this.state.course);
    let findCourse = _.find(cloneCourse, (item) => {
      return item.courseId === courseId;
    });
    if (findCourse) {
      findCourse.stage1.applicationStatus = val;
      this.setState({ course: cloneCourse });
    }
  }

  openOfferDrawerFxn(date, item) {
    this.setState({
      showOfferDateDrawer: true,
      offerExpDate: date,
      choosenCourseId: item.courseId,
    });
  }

  setReUploadFields(val, index, field) {
    let cloneCourse = _.clone(this.state.course);
    cloneCourse[index].stage2Clone[field] = val;
    this.setState({ course: cloneCourse });
  }

  setReUploadChannelFields(val, index, field) {
    let cloneCourse = _.clone(this.state.course);
    if (cloneCourse[index].stage2.channelPartnerName === undefined) {
      cloneCourse[index].stage2 = {
        ...cloneCourse[index].stage2,
        channelPartnerName: "",
      };
    }
    if (cloneCourse[index].channelPartnerName === undefined) {
      cloneCourse[index] = {
        ...cloneCourse[index],
        channelPartnerName: "",
      };
    }

    let clonedItem = cloneCourse[index];
    if (clonedItem.channelPartners) {
      for (
        let loopIndex = 0;
        loopIndex < clonedItem.channelPartners.length;
        loopIndex++
      ) {
        const element = clonedItem.channelPartners[loopIndex];
        if (this.normalizeId(element._id) === val) {
          cloneCourse[index].channelPartnerName =
            element.channelPartnerName +
            " " +
            (element.preferredPartner ? "(Preferred)" : "");
          cloneCourse[index].stage2.channelPartnerName =
            element.channelPartnerName +
            " " +
            (element.preferredPartner ? "(Preferred)" : "");
        }
      }
    }
    cloneCourse[index].stage2[field] = val;
    cloneCourse[index][field] = val;
    this.setState({ course: cloneCourse });
  }

  loadCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
      businessId: activeUser && activeUser.businessId
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryFieldArr = [];
        let processes = {}
        resp.data = resp.data.reduce((temp, vv) => {
          processes[this.normalizeId(vv._id)] = vv.process ? vv.process : []
          countryFieldArr.push({ _id: this.normalizeId(vv._id), display: vv.countryName });
          temp.push({ ...vv });
          return temp;
        }, []);
        this.setState({ countryFieldArr: countryFieldArr, processes });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSubmitTab1 = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const formData = {
          passportNumber: valData.passportNumber,
          issueDate: valData.issueDate,
          expiryDate: valData.expiryDate,
          issueCountryId: valData.issueCountryId,
        };
        let x = await Request.updateInquiryPassportDetails(
          formData,
          this.state.inquiryId
        );
        dispatch(hideLoader());
        if (!x.error) {
          notification.success({
            message: "Inquiry Passport Info Update Successfully",
          });
        } else {
          notification.error({
            message: "Error Saving",
            description: x.msg,
          });
        }
      }
    });
  };

  applicationDateHtml(item) {
    return (
      <div>
        {item && item.stage1 && item.stage1.status ? (
          <ul className={common.ulNew}>
            {item && item.stage1 && item.stage1.status ? (
              <li>Application {item.stage1.status}</li>
            ) : null}

            {item && item.stage2 && item.stage2.offerExpDate ? (
              <li>
                <Icon type="right" />{" "}
                {moment(item.stage2.offerExpDate).format("DD-MMM-YYYY")}
              </li>
            ) : null}

            {item && item.stage2 && item.stage2.courseStartDate ? (
              <li>
                <Icon type="right" />{" "}
                {moment(item.stage2.courseStartDate).format("DD-MMM-YYYY")}
              </li>
            ) : null}

            {item && item.stage2 && item.stage2.feeDueDate ? (
              <li>
                <Icon type="right" />{" "}
                {moment(item.stage2.feeDueDate).format("DD-MMM-YYYY")}
              </li>
            ) : null}
          </ul>
        ) : null}
      </div>
    );
  }


  closeUpdateDrawer = () => {
    this.setState({ updateCourseDrawer: false, updateCourseId: null }, () => {
      window.location.reload();
    })
  }



  viewUniversityFiles = (universityId) => {
    this.props.dispatch(
      getUrlPushWrapper("report.libraryReport", { universityId: universityId })
    );
  };

  render() {
    const { dispatch } = this.props;
    const {
      info,
      course,
      choosenCourseId,
      inquiryId,
      moveToNextDesk,
      moveType,
      nextYears
    } = this.state;

    const offerStatusView = (item, offerurl, index) => {
      return (
        <Col span={24} style={{ backgroundColor: "#f7f1cd", padding: 7 }}>
          <Row>
            <Col span={12}>
              <div style={{ marginBottom: 10 }}>Status {item.uploadStatus}</div>
              <Select
                style={{ width: 300 }}
                value={item.uploadStatus}
                onChange={(val) => {
                  this.setUploadFields(val, index, "uploadStatus");
                  // this.setApplicationStatus(val, item.courseId)
                }}
                defaultValue={"Offer Pending"}
              >
                {(() => {
                  const countryOfferStatuses = this.state.processes && this.state.processes[item.countryId]
                    ? this.state.processes[item.countryId]
                      .filter(statusI => statusI.desk === "Application Offer Status" && statusI.active === true)
                      .map(statusI => ({ value: statusI.systemKey || statusI.name, label: statusI.name }))
                    : [];
                  const list = useCountrySpecificStatus && countryOfferStatuses.length ? countryOfferStatuses : offerStatusList.map(statusI => ({ value: statusI, label: statusI }));
                  return list.map((statusI, statusK) => (
                    <Option value={statusI.value} key={statusK}>
                      {statusI.label}
                    </Option>
                  ));
                })()}
              </Select>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 10 }}>Upload Offer File Here</div>
              <Upload
                size={"small"}
                name={"file"}
                action={`${LAPI_URL}/filesUploader`}
                onChange={this.handleChange}
                onRemove={this.onRemove}
              >
                <Button>
                  <Icon type="upload" /> Choose Offer File
                </Button>
              </Upload>
              {offerurl ? (
                <a
                  href={`${offerurl}`}
                  style={{
                    color: "blue",
                    textDecorationLine: "underline",
                  }}
                  target={"_blank"}
                >
                  Download Offer <Icon type="download" />
                </a>
              ) : null}
            </Col>
          </Row>
          {item.uploadStatus === "Interview Required" ? (
            <Row style={{ marginTop: 10 }}>
              <Col span={6}>
                <div style={{ marginBottom: 10 }}>Interview Date</div>
                <DatePicker
                  format={"DD-MMM-YYYY"}
                  onChange={(v) => {
                    this.setUploadFields(v, index, "interviewDate");
                  }}
                />
              </Col>
              <Col span={12}>
                <div style={{ marginBottom: 10 }}>Interview Outcome</div>
                <Select
                  style={{ width: 300 }}
                  value={item.interviewOutcome}
                  onChange={(val) => {
                    this.setUploadFields(val, index, "interviewOutcome");
                    // this.setApplicationStatus(val, item.courseId)
                  }}
                >
                  <Option value={'Cleared'} key={'Cleared'}>Cleared</Option>
                  <Option value={'Declined'} key={'Declined'}>Declined</Option>
                  {/* {offerStatusList.map((statusI, statusK) => {
                  return (
                    <Option value={statusI} key={statusK}>
                      {statusI}
                    </Option>
                  );
                })} */}
                </Select>
              </Col>
            </Row>
          ) : null}
          {item.uploadStatus === "Conditional Offer Received" ||
            item.uploadStatus === "Unconditional Offer Received" ? (
            <div>
              <Row style={{ marginTop: 10 }}>
                <Col span={6}>
                  <div style={{ marginBottom: 10 }}>Course Start Date</div>
                  <DatePicker
                    format={"DD-MMM-YYYY"}
                    onChange={(v) => {
                      this.setUploadFields(v, index, "courseStartDate");
                    }}
                  />
                </Col>
                <Col span={4}>
                  <div style={{ marginBottom: 10 }}>Fee Due Date</div>
                  <DatePicker
                    format={"DD-MMM-YYYY"}
                    onChange={(v) => {
                      this.setUploadFields(v, index, "feeDueDate");
                    }}
                  />
                </Col>
                <Col span={7}>
                  <div style={{ marginBottom: 10 }}>Institute Student Id</div>
                  <Input
                    type={"text"}
                    placeholder={"Institute Student Id"}
                    required
                    onChange={(v) => {
                      this.setUploadFields(
                        v.target.value,
                        index,
                        "instituteStudentId"
                      );
                    }}
                  />
                </Col>
                <Col span={7}>
                  {showChannelPartner &&
                    item.channelPartners &&
                    item.channelPartners.length > 0 && (
                      <>
                        <div style={{ marginBottom: 10 }}>Channel Partner</div>
                        <Select
                          value={
                            item.channelPartnerId ? item.channelPartnerId : ""
                          }
                          style={{ width: 250 }}
                          showSearch={true}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toString()
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                          }
                          onChange={(channelPartner) => {
                            this.setReUploadChannelFields(
                              channelPartner,
                              index,
                              "channelPartnerId"
                            );
                          }}
                        >
                          <Option value={null}>Select Channel Partner</Option>
                          {item.channelPartners.map((el, key) => {
                            return (
                              <Option key={key} value={this.normalizeId(el._id)}>
                                {el.channelPartnerName}{" "}
                                {el.preferredPartner ? "(Preferred)" : ""}
                              </Option>
                            );
                          })}
                        </Select>
                      </>
                    )}
                </Col>
              </Row>


            </div>
          ) : null}
          {
            item.uploadStatus === "Conditional Offer Received" || item.uploadStatus === "Additional Docs Required" ?
              <Row style={{ marginTop: 10 }}>
                <div style={{ marginBottom: 10 }}>Documents Required</div>
                <TextArea rows={6}
                  placeholder={"Documents Required"}
                  required
                  onChange={(v) => {
                    this.setUploadFields(
                      v.target.value,
                      index,
                      "documentsRequired"
                    );
                  }} />
              </Row> : null
          }
          {
            item.uploadStatus === "Offer Rejected" && (
              <Row style={{ marginTop: 10 }}>
                <div style={{ marginBottom: 10 }}>Rejection Reason</div>
                <TextArea rows={6}
                  placeholder={"Rejection Reason"}
                  required
                  onChange={(v) => {
                    this.setUploadFields(
                      v.target.value,
                      index,
                      "offerRejectionReason"
                    );
                  }} />
              </Row>
            )
          }
          <Row>
            <Col span={24} style={{ marginTop: 24 }}>
              <Button
                type={"info"}
                loading={this.props.loading}
                onClick={() => this.uploadOffer(item.courseId, item)}
                icon={"save"}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      );
    };
    const offerStatusView2 = (item, offerurl, index) => {
      const { stage2Clone } = item;
      return (
        <Col span={24} style={{ backgroundColor: "#f7f1cd", padding: 7 }}>
          <Row>
            <Col span={12}>
              <div style={{ marginBottom: 10 }}>Status</div>
              <Select
                style={{ width: 200 }}
                value={item.stage2Clone.offerStatus}
                onChange={(val) => {
                  this.setReUploadFields(val, index, "offerStatus");
                }}
                defaultValue={"Offer Pending"}
              >
                {(() => {
                  const countryOfferStatuses = this.state.processes && this.state.processes[item.countryId]
                    ? this.state.processes[item.countryId]
                      .filter(statusI => statusI.desk === "Application Offer Status" && statusI.active === true)
                      .map(statusI => ({ value: statusI.systemKey || statusI.name, label: statusI.name }))
                    : [];
                  const list = useCountrySpecificStatus && countryOfferStatuses.length ? countryOfferStatuses : offerStatusList.map(statusI => ({ value: statusI, label: statusI }));
                  return list.map((statusI, statusK) => (
                    <Option value={statusI.value} key={statusK}>
                      {statusI.label}
                    </Option>
                  ));
                })()}
              </Select>
            </Col>
            <Col span={12}>
              <div style={{ marginBottom: 10 }}>Upload Offer File Here</div>
              <Upload
                size={"small"}
                name={"file"}
                action={`${LAPI_URL}/filesUploader`}
                onChange={this.handleChange}
                onRemove={this.onRemove}
              >
                <Button>
                  <Icon type="upload" /> Choose Offer File
                </Button>
              </Upload>
              {offerurl ? (
                <a
                  href={`${offerurl}`}
                  style={{
                    color: "blue",
                    textDecorationLine: "underline",
                  }}
                  target={"_blank"}
                >
                  Download Offer <Icon type="download" />
                </a>
              ) : null}
            </Col>
          </Row>
          {item.stage2Clone.offerStatus === "Conditional Offer Received" ||
            item.stage2Clone.offerStatus === "Unconditional Offer Received" ? (
            <Row style={{ marginTop: 10 }}>
              <Col span={6}>
                <div style={{ marginBottom: 10 }}>Course Start Date</div>
                <DatePicker
                  format={"DD-MMM-YYYY"}
                  value={
                    stage2Clone.courseStartDate
                      ? moment(stage2Clone.courseStartDate)
                      : ""
                  }
                  onChange={(v) => {
                    this.setReUploadFields(v, index, "courseStartDate");
                  }}
                />
              </Col>
              <Col span={4}>
                <div style={{ marginBottom: 10 }}>Fee Due Date</div>
                <DatePicker
                  format={"DD-MMM-YYYY"}
                  value={
                    stage2Clone.feeDueDate ? moment(stage2Clone.feeDueDate) : ""
                  }
                  onChange={(v) => {
                    this.setReUploadFields(v, index, "feeDueDate");
                  }}
                />
              </Col>
              <Col span={7}>
                <div style={{ marginBottom: 10 }}>Institute Student Id</div>
                <Input
                  type={"text"}
                  placeholder={"Institute Student Id"}
                  required
                  value={
                    stage2Clone.instituteStudentId
                      ? stage2Clone.instituteStudentId
                      : ""
                  }
                  onChange={(v) => {
                    this.setReUploadFields(
                      v.target.value,
                      index,
                      "instituteStudentId"
                    );
                  }}
                />
              </Col>
              <Col span={7}>
                {showChannelPartner &&
                  item.channelPartners &&
                  item.channelPartners.length > 0 && (
                    <>
                      <div style={{ marginBottom: 10 }}>Channel Partner</div>
                      <Select
                        required
                        value={
                          item.channelPartnerId ? item.channelPartnerId : ""
                        }
                        style={{ width: 250 }}
                        showSearch={true}
                        filterOption={(inputValue, option) =>
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        onChange={(channelPartner) => {
                          this.setReUploadChannelFields(
                            channelPartner,
                            index,
                            "channelPartnerId"
                          );
                        }}
                      >
                        <Option value={null}>Select Channel Partner</Option>
                        {item.channelPartners.map((el, key) => {
                          return (
                            <Option key={key} value={this.normalizeId(el._id)}>
                              {el.channelPartnerName}{" "}
                              {el.preferredPartner ? "(Preferred)" : ""}
                            </Option>
                          );
                        })}
                      </Select>
                    </>
                  )}
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col span={24} style={{ marginTop: 24 }}>
              <Button
                type={"info"}
                loading={this.props.loading}
                onClick={() => this.reUploadOffer(item.courseId, item)}
                icon={"save"}
              >
                Re-Upload
              </Button>
            </Col>
          </Row>
        </Col>
      );
    };

    const passportInputSchema = {
      fields: [
        {
          label: "Passport Number",
          key: "passportNumber",
          required: true,
          customProps: {
            style: {
              width: "310px",
            },
          },
          type: "text",
        },
        {
          label: "Expiry Date",
          key: "expiryDate",
          required: true,
          customProps: {
            style: {
              width: "310px",
            },
          },
          type: "date",
        },
      ],
    };
    const passportInputSchema2 = {
      fields: [
        {
          label: "Issue Date",
          key: "issueDate",
          required: true,
          customProps: {
            style: {
              width: "310px",
            },
          },
          type: "date",
        },
        {
          label: "Issue Country",
          key: "issueCountryId",
          showSearch: true,
          required: true,
          type: "select",
          defaultValue: "nfjw",
          customProps: {
            style: {
              width: "310px",
            },
          },
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              issueCountryId: v,
            });
          },
        },
      ],
    };

    const {
      form: { getFieldDecorator },
    } = this.props;

    return (
      <PageHeaderWrapper
        title={
          info && info.studentName
            ? `Application of ${info.studentName}`
            : "Application Screen"
        }
      >
        {
          this.state.updateCourseDrawer ?
            <UpdateCourse inquiryId={this.state.inquiryId} cousreId={this.state.updateCourseId} onClose={this.closeUpdateDrawer} />
            : null
        }
        {info && this.normalizeId(info._id) ? (
          <div>
            <div style={{ marginBottom: 10 }}>
              <StudentHeader
                rollBackLevel={"Registration Desk"}
                done={() => {
                  dispatch(getUrlPushWrapper("desk.application"));
                }}
                info={this.state.inquiryId}
                data={info}
                dispatch={this.props.dispatch}
              />
            </div>
          </div>
        ) : null}

        {info ? (
          <Card bordered={true} style={{ marginBottom: 10 }}>
            <StudentInfo info={info} />
          </Card>
        ) : null}

        {moveType === "Partial" ? (
          <Card bordered={true} style={{ marginBottom: 10 }}>
            <p style={{ color: "red" }}>
              <b>Hi {JSON.parse(localStorage.getItem("user")).name}</b>,
              Application moved to visa desk partially, Please completed missing
              info!!!.
            </p>
          </Card>
        ) : null}

        <Card bordered={true} loading={!info}>
          <Form onSubmit={this.handleSubmitTab1} style={{ marginTop: 1 }}>
            <Row>
              <Col span={24}>
                <h3 style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                  Passport Information
                </h3>
              </Col>
              <Col span={10}>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={passportInputSchema}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={10}>
                <GetAllFormFields
                  apiurl={LAPI_URL}
                  inputSchema={passportInputSchema2}
                  getFieldDecorator={getFieldDecorator}
                />
              </Col>
              <Col span={4}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10, float: "right", width: "130px" }}
                  loading={this.props.loading}
                >
                  Update
                </Button>
              </Col>
            </Row>
          </Form>

          {info && info.atLevel === "Application Desk" ? (
            <Button
              type="default"
              onClick={() => this.showDrawer()}
              style={{ marginBottom: 10 }}
            >
              Click here to choose a course2
            </Button>
          ) : null}

          {this.state.visible ? (
            <CourseFinder
              inquiryId={inquiryId}
              inquiryProfile={info.profile}
              inquiryTotalPreference={info.totalPreference}
              callback={this.calback}
              onClose={this.closeFollowUp}
              removeCourse={this.removeCourse}
              selectCourseIds={this.state.course}
            />
          ) : (
            ""
          )}

          {this.state.mailer ? (
            <ApplicationMailer
              inquiryId={inquiryId}
              courseId={choosenCourseId}
              studentName={info.studentName}
              ref={this.mailer}
              callback={this.MailerCallback}
              onClose={this.closeMailer}
            />
          ) : (
            ""
          )}

          {this.state.showOfferDateDrawer ? (
            <ApplicationOfferExpected
              inquiryId={inquiryId}
              courseId={choosenCourseId}
              offerExpDate={this.state.offerExpDate}
              studentName={info.studentName}
              ref={this.updateExpDate}
              onClose={this.closeOfferDrawer}
            />
          ) : null}

          <div style={{ background: "#ECECEC", padding: "10px" }}>
            <Row>
              {course &&
                course.map((item, index) => {
                  debugger;
                  const shouldShowChannelPartner =
                    showChannelPartner === true &&
                    item.channelPartners &&
                    Array.isArray(item.channelPartners) &&
                    item.channelPartners.length > 0;

                  console.log("CHANNEL PARTNER CHECK", {
                    index: index,
                    showChannelPartner: showChannelPartner,
                    isArray: Array.isArray(item.channelPartners),
                    length: item.channelPartners ? item.channelPartners.length : 0,
                    shouldShowChannelPartner: shouldShowChannelPartner,
                    channelPartnerId: item.channelPartnerId,
                  });
                  const { stage1, stage2 } = item;
                  let offerurl = null;
                  if (stage2 && stage2.offerUpload && stage2.offerUpload.url) {
                    offerurl = `${LAPI_URL}/file/${stage2 && stage2.offerUpload && stage2.offerUpload.url
                      ? stage2.offerUpload.url
                      : null
                      }`;
                  }

                  return (
                    <Col key={index}>
                      <div className={common.custCard}>
                        <div className={common.section}>
                          {this.applicationDateHtml(item)}
                          <div>
                            <b>{item.courseName}</b> (
                            {item.universityInstitutionName})
                          </div>
                          <div>Fee: {item.tutionFee} </div>
                          {showChannelPartner &&
                            item.channelPartnerName !== undefined &&
                            item.channelPartnerName ? (
                            <div>
                              <b>Channel Partner:</b> {item.channelPartnerName}{" "}
                            </div>
                          ) : null}
                          {item.pathwayName ? (
                            <div>Pathway: {item.pathwayName} </div>
                          ) : null}

                          <div style={{ float: "right", marginTop: -20 }}>
                            <label>Change of Agent:- </label>
                            <Tooltip title="Change of Agent" >
                              <Switch disabled={item.changeOfAgent} checked={item.changeOfAgent} onChange={(checked) => {
                                this.handleChangeOfAgent({ checked, courseId: item.courseId, inquiryId })
                              }} />
                            </Tooltip>
                            <Tooltip title="View Files">
                              <Button
                                type="warning"
                                style={{ marginLeft: 10 }}
                                className={styles.btnNew}
                                shape="circle"
                                onClick={() => {
                                  this.viewUniversityFiles(item.universityId);
                                }}
                                icon="file"
                              />
                            </Tooltip>
                            <RightsWrapper myRight={"editCourseFromApplication.view"}>
                              <Popconfirm title="Are you sure to Edit this course?"
                                onConfirm={() => {
                                  this.setState({ updateCourseDrawer: true, updateCourseId: item })
                                }}
                                onCancel={() => {
                                  console.log();
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button shape="circle" icon="edit" />
                              </Popconfirm>
                            </RightsWrapper>
                            {/* <RightsWrapper myRight={"removeCourseFromApplication.view"}>
                              <Popconfirm
                                title="Are you sure remove this course?"
                                onConfirm={() => {
                                  this.removeAppCourse(item.courseId);
                                }}
                                onCancel={() => {
                                  console.log();
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button shape="circle" icon="delete" />
                              </Popconfirm>
                            </RightsWrapper> */}
                          </div>
                        </div>
                        <div className={common.section}>
                          {!item.intake ?
                            item.intakes && item.intakes.length ?
                              <Row style={{ alignItems: 'center' }}>
                                <Col span={2}>Choose Intake: </Col>
                                <Col span={3}>
                                  <Select
                                    style={{ width: 120 }}
                                    onChange={(val) => {
                                      item.choosenIntake = val;
                                    }}
                                  >
                                    {item.intakes &&
                                      item.intakes.map((ink, inkin) => {
                                        return (
                                          <Option key={inkin} value={ink}>
                                            {ink}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Col>
                                <Col span={2}>Choose Year: </Col>
                                <Col span={3}>
                                  <Select
                                    style={{ width: 120 }}
                                    onChange={(val) => {
                                      item.choosenYear = val;
                                    }}
                                  >
                                    {nextYears && nextYears.map((year) => (
                                      <Option value={year}>{year}</Option>
                                    ))}
                                  </Select>
                                </Col>

                                <Col span={2}>Choose Campus: </Col>
                                <Col span={3}>
                                  {item.mainCampus && item.mainCampus.length > 0 && (
                                    <Select
                                      defaultValue={{ key: this.normalizeId(item.campusId) }}
                                      style={{ width: 150 }}
                                      labelInValue
                                      showSearch={true}
                                      filterOption={(inputValue, option) =>
                                        option.props.children
                                          .toString()
                                          .toLowerCase()
                                          .includes(inputValue.toLowerCase())
                                      }
                                      onChange={(campus) => {
                                        if (campus) {
                                          item.campusId = campus.key;
                                          item.campusName = campus.label;
                                        } else {
                                          item.campusId = null;
                                          item.campusName = null;
                                        }
                                      }}
                                    >
                                      <Option value={null}>Select Campus</Option>
                                      {item.mainCampus.map((el, key) => {
                                        return (
                                          <Option key={key} value={this.normalizeId(el._id)}>
                                            {el.campusName}
                                          </Option>
                                        );
                                      })}
                                    </Select>
                                  )}
                                </Col>
                                {showChannelPartner &&
                                  item.channelPartners &&
                                  item.channelPartners.length > 0 && (
                                    <Col span={2}>Channel Partner: </Col>
                                  )}

                                <Col span={6}>
                                  {showChannelPartner &&
                                    item.channelPartners &&
                                    item.channelPartners.length > 0 && (
                                      <Select
                                        defaultValue={{
                                          key: item.channelPartnerId,
                                        }}
                                        labelInValue
                                        style={{ width: 300 }}
                                        showSearch={true}
                                        filterOption={(inputValue, option) =>
                                          option.props.children
                                            .toString()
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase())
                                        }
                                        onChange={(channelPartner) => {
                                          if (channelPartner) {
                                            item.channelPartnerId =
                                              channelPartner.key;
                                            item.channelPartnerName =
                                              channelPartner.label;
                                          } else {
                                            item.channelPartnerId = null;
                                            item.channelPartnerName = null;
                                          }
                                        }}
                                      >
                                        <Option value={null}>
                                          Select Channel Partner
                                        </Option>
                                        {item.channelPartners.map((el, key) => {
                                          return (
                                            <Option key={key} value={this.normalizeId(el._id)}>
                                              {el.channelPartnerName}{" "}
                                              {el.preferredPartner
                                                ? "(Preferred)"
                                                : ""}
                                            </Option>
                                          );
                                        })}
                                      </Select>
                                    )}
                                </Col>

                                <Col span={1}>
                                  <Button
                                    loading={this.props.loading}
                                    onClick={() => {
                                      this.saveApplicationIntake(item);
                                    }}
                                    type={"primary"}
                                  >
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                              : <Row>
                                <Col>
                                  <span style={{ color: '#ff4d4f', fontWeight: 500 }}>
                                    ⚠ Intake details are missing in this course. Please update the intake before proceeding.
                                  </span>
                                </Col>
                              </Row>
                            : null}
                          {!item.intake &&
                            item.intakes &&
                            item.intakes.length ? (
                            <></>
                            // <Row style={{ alignItems: 'center' }}>
                            //   <Col span={2}>Choose Intake: </Col>
                            //   <Col span={3}>
                            //     <Select
                            //       style={{ width: 120 }}
                            //       onChange={(val) => {
                            //         item.choosenIntake = val;
                            //       }}
                            //     >
                            //       {item.intakes &&
                            //         item.intakes.map((ink, inkin) => {
                            //           return (
                            //             <Option key={inkin} value={ink}>
                            //               {ink}
                            //             </Option>
                            //           );
                            //         })}
                            //     </Select>
                            //   </Col>
                            //   <Col span={2}>Choose Year: </Col>
                            //   <Col span={3}>
                            //     <Select
                            //       style={{ width: 120 }}
                            //       onChange={(val) => {
                            //         item.choosenYear = val;
                            //       }}
                            //     >
                            //       {nextYears && nextYears.map((year) => (
                            //         <Option value={year}>{year}</Option>
                            //       ))}
                            //       {/* <Option value="2019">2019</Option>
                            //       <Option value="2020">2020</Option>
                            //       <Option value="2021">2021</Option>
                            //       <Option value="2022">2022</Option>
                            //       <Option value="2023">2023</Option>
                            //       <Option value="2024">2024</Option>
                            //       <Option value="2025">2025</Option>
                            //       <Option value="2026">2026</Option>
                            //       <Option value="2027">2027</Option>
                            //       <Option value="2028">2028</Option> */}
                            //     </Select>
                            //   </Col>

                            //   <Col span={2}>Choose Campus: </Col>
                            //   <Col span={3}>
                            //     {item.mainCampus && item.mainCampus.length > 0 && (
                            //       <Select
                            //         defaultValue={{ key: this.normalizeId(item.campusId) }}
                            //         style={{ width: 150 }}
                            //         labelInValue
                            //         showSearch={true}
                            //         filterOption={(inputValue, option) =>
                            //           option.props.children
                            //             .toString()
                            //             .toLowerCase()
                            //             .includes(inputValue.toLowerCase())
                            //         }
                            //         onChange={(campus) => {
                            //           if (campus) {
                            //             item.campusId = campus.key;
                            //             item.campusName = campus.label;
                            //           } else {
                            //             item.campusId = null;
                            //             item.campusName = null;
                            //           }
                            //         }}
                            //       >
                            //         <Option value={null}>Select Campus</Option>
                            //         {item.mainCampus.map((el, key) => {
                            //           return (
                            //             <Option key={key} value={this.normalizeId(el._id)}>
                            //               {el.campusName}
                            //             </Option>
                            //           );
                            //         })}
                            //       </Select>
                            //     )}
                            //   </Col>
                            //   {showChannelPartner &&
                            //     item.channelPartners &&
                            //     item.channelPartners.length > 0 && (
                            //       <Col span={2}>Channel Partner: </Col>
                            //     )}

                            //   <Col span={6}>
                            //     {showChannelPartner &&
                            //       item.channelPartners &&
                            //       item.channelPartners.length > 0 && (
                            //         <Select
                            //           defaultValue={{
                            //             key: item.channelPartnerId,
                            //           }}
                            //           labelInValue
                            //           style={{ width: 300 }}
                            //           showSearch={true}
                            //           filterOption={(inputValue, option) =>
                            //             option.props.children
                            //               .toString()
                            //               .toLowerCase()
                            //               .includes(inputValue.toLowerCase())
                            //           }
                            //           onChange={(channelPartner) => {
                            //             if (channelPartner) {
                            //               item.channelPartnerId =
                            //                 channelPartner.key;
                            //               item.channelPartnerName =
                            //                 channelPartner.label;
                            //             } else {
                            //               item.channelPartnerId = null;
                            //               item.channelPartnerName = null;
                            //             }
                            //           }}
                            //         >
                            //           <Option value={null}>
                            //             Select Channel Partner
                            //           </Option>
                            //           {item.channelPartners.map((el, key) => {
                            //             return (
                            //               <Option key={key} value={this.normalizeId(el._id)}>
                            //                 {el.channelPartnerName}{" "}
                            //                 {el.preferredPartner
                            //                   ? "(Preferred)"
                            //                   : ""}
                            //               </Option>
                            //             );
                            //           })}
                            //         </Select>
                            //       )}
                            //   </Col>

                            //   <Col span={1}>
                            //     <Button
                            //       loading={this.props.loading}
                            //       onClick={() => {
                            //         this.saveApplicationIntake(item);
                            //       }}
                            //       type={"primary"}
                            //     >
                            //       Save
                            //     </Button>
                            //   </Col>
                            // </Row>
                          ) : null}

                          {item.intake ? (
                            <Row>
                              <Col className={common.success}>
                                <b>(1) Intake : </b>
                                {item.intake} {item.intakeYear}{" "}
                                <Icon type={"check"} />
                              </Col>
                            </Row>
                          ) : null}
                        </div>

                        {stage1 && stage1.status !== "Offer Expected on" ? (
                          <div className={common.section}>
                            <Row>
                              <Col span={4} className={common.label}>
                                Application Status
                              </Col>
                              <Col span={6}>
                                <Select
                                  style={{ width: 220 }}
                                  value={stage1.applicationStatus}
                                  onChange={(val) => {
                                    this.setApplicationStatus(
                                      val,
                                      item.courseId
                                    );
                                  }}
                                >
                                  {(() => {
                                    const countryStatuses = this.state.processes && this.state.processes[item.countryId]
                                      ? this.state.processes[item.countryId]
                                        .filter(statusI => statusI.desk === "Application Status" && statusI.active === true)
                                        .map(statusI => ({ value: statusI.systemKey || statusI.name, label: statusI.name }))
                                      : [];
                                    const list = useCountrySpecificStatus && countryStatuses.length ? countryStatuses : statusList.map(statusI => ({ value: statusI, label: statusI === "Pending Documents" ? "Documents Pending" : statusI }));
                                    return list.map((statusI, statusK) => (
                                      <Option value={statusI.value} key={statusK}>
                                        {statusI.label}
                                      </Option>
                                    ));
                                  })()}
                                </Select>
                              </Col>
                              <Col span={4}>
                                <Button
                                  size={"default"}
                                  loading={this.props.loading}
                                  onClick={() =>
                                    this.saveApplicationStatus(item)
                                  }
                                  type={"primary"}
                                >
                                  SAVE
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                        {stage1 && stage1.status === "Offer Expected on" ? (
                          <div className={common.section}>
                            <Row>
                              <Col className={common.success}>
                                <b>(2) Application Status : </b>
                                {stage1.status} <Icon type={"check"} />
                              </Col>
                            </Row>
                          </div>
                        ) : null}
                        {stage1 && stage1.status === "Offer Expected on" ? (
                          <div className={common.section}>
                            {stage2 && stage2.mailStatus === "Not Sent" ? (
                              <Row>
                                <Col>
                                  <Button
                                    onClick={() => this.showMailer(item)}
                                    type={"warning"}
                                    size={"small"}
                                  >
                                    {/*Send Email */}
                                    Offer Expected Date
                                  </Button>
                                </Col>
                              </Row>
                            ) : null}

                            {stage2 && stage2.offerExpDate ? (
                              <Row>
                                <Col span={4} className={common.blue}>
                                  Offer Expect Date <Icon type={"check"} />
                                  <div>
                                    {/*<small>{moment(stage2.offerExpDate).format('DD-MMM-YYYY')} </small>*/}
                                    <Button
                                      size={"small"}
                                      style={{ marginTop: 2 }}
                                      onClick={() =>
                                        this.openOfferDrawerFxn(
                                          stage2.offerExpDate,
                                          item
                                        )
                                      }
                                    >
                                      {moment(stage2.offerExpDate).format(
                                        "DD-MMM-YYYY"
                                      )}
                                    </Button>
                                  </div>
                                </Col>
                                <Col span={4} className={common.success}>
                                  Application Processed <Icon type={"check"} />
                                  <div>
                                    <small>
                                      {moment(stage2.mailStatusDate).format(
                                        "DD-MMM-YYYY"
                                      )}{" "}
                                    </small>
                                  </div>
                                </Col>
                                {stage2.offerExpDate &&
                                  (stage2.offerStatus !==
                                    "Conditional Offer Received" &&
                                    stage2.offerStatus !== "Offer Rejected" &&
                                    stage2.offerStatus !==
                                    "Unconditional Offer Received") &&
                                  !stage2.uploadedDone ? (
                                  offerStatusView(item, offerurl, index)
                                ) : (
                                  <Row>
                                    {stage2.courseStartDate ? (
                                      <Col span={4} className={common.blue}>
                                        Course Start Date{" "}
                                        <Icon type={"check"} />
                                        <div>
                                          <small>
                                            {moment(
                                              stage2.courseStartDate
                                            ).format("DD-MMM-YYYY")}{" "}
                                          </small>
                                        </div>
                                      </Col>
                                    ) : null}

                                    {stage2.feeDueDate ? (
                                      <Col span={4} className={common.blue}>
                                        Due Fees Date <Icon type={"check"} />
                                        <div>
                                          <small>
                                            {moment(stage2.feeDueDate).format(
                                              "DD-MMM-YYYY"
                                            )}{" "}
                                          </small>
                                        </div>
                                      </Col>
                                    ) : null}

                                    {stage2.elicos ? (
                                      <Col span={4} className={common.blue}>
                                        Elicos(in weeks) <Icon type={"check"} />
                                        <div>
                                          <small>
                                            {stage2.elicos}{" "}
                                            {stage2.elicos > 1
                                              ? "Weeks"
                                              : "Week"}
                                          </small>
                                        </div>
                                      </Col>
                                    ) : null}

                                    {offerurl ? (
                                      <Col span={4}>
                                        <a
                                          href={`${offerurl}`}
                                          style={{
                                            color: "blue",
                                            textDecorationLine: "underline",
                                          }}
                                          target={"_blank"}
                                        >
                                          Download Offer{" "}
                                          <Icon type="download" />
                                        </a>
                                      </Col>
                                    ) : null}
                                  </Row>
                                )}

                                <div className={styles.offerReUpload}>
                                  {stage2 &&
                                    stage2.offerUpload &&
                                    stage2.offerUpload.url &&
                                    stage2.offerStatus &&
                                    stage2.uploadedDone
                                    ? offerStatusView2(item, offerurl, index)
                                    : null}
                                </div>
                              </Row>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  );
                })}
              {moveToNextDesk ? (
                <Col span={24}>
                  <Card>
                    <div className={common.section}>
                      <Row>
                        <Col span={4}>
                          <h4>Notification To Counselor</h4>
                          <Select
                            style={{ width: 120 }}
                            defaultValue={this.state.smsCounselor}
                            placeholder={"Sms Counselor"}
                            onChange={(val) => {
                              this.setState({ smsCounselor: val });
                            }}
                          >
                            <Option value={"Yes"}>Yes</Option>
                            <Option value={"No"}>No</Option>
                          </Select>
                        </Col>
                        {this.state.displayAggrementSigned ? (
                          <Col span={4}>
                            <h4>Agreement Signed</h4>
                            <Select
                              style={{ width: 120 }}
                              defaultValue={this.state.aggrementSigned}
                              placeholder={"Agreement Signed"}
                              onChange={(val) => {
                                this.setState({ aggrementSigned: val });
                              }}
                            >
                              <Option value={"Yes"}>Yes</Option>
                              <Option value={"No"}>No</Option>
                            </Select>
                          </Col>
                        ) : null}
                        <Col span={6}>
                          <h4>Select Visa Desk User</h4>
                          <Select
                            style={{ width: "200px" }}
                            showSearch={true}
                            mode="multiple"
                            value={
                              this.state.visaUserId ? this.state.visaUserId : []
                            }
                            onChange={(item) => {
                              this.setState({ visaUserId: item });
                            }}
                          >
                            {this.state.allUsers.map((item) => (
                              <Option key={this.normalizeId(item._id)} value={this.normalizeId(item._id)}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Col>

                        <Col span={4} style={{ marginTop: 20 }}>
                          <Button
                            type="primary"
                            size={"medium"}
                            style={{ marginBottom: 10 }}
                            onClick={() => {
                              let { info } = this.state;
                              // if (
                              //   info &&
                              //   info.profile &&
                              //   (
                              //     !info.profile.newQualification ||
                              //     !info.profile.newQualification.length ||
                              //     !(
                              //       info.haveEnglishTestScore === 'Yes' ||
                              //       info.haveEnglishTestScore === 'true' ||
                              //       info.haveEnglishTestScore === true
                              //     )
                              //   )
                              // ) {
                              //   return notification.error({
                              //     message:
                              //       "This student does not have a qualification or English Test score. Please update the details before proceeding.",
                              //   });
                              // }
                              if (this.state.visaUserId.length === 0) {
                                return notification.error({
                                  message:
                                    "Please select Visa Desk User to move the student to Visa Desk.",
                                });
                              }
                              const { dispatch } = this.props;

                              if (pendingConsultancyAlertToAdmissionVisa) {
                                let { inquiryInfo } = this.state;
                                let stage = 1
                                let amountStages = inquiryInfo.registrationDesk.total / 3
                                if (inquiryInfo.registrationDesk.paid < amountStages) {
                                  notification.warn({
                                    message: `You are Forwarding to Visa Desk without charging stage ${stage} consultancy fees, You are answerable`
                                  })
                                }
                              }

                              if (this.state.aggrementSigned === "Yes") {
                                dispatch(showLoader());
                                Request.movedToVisaDesk({
                                  _id: this.state.inquiryId,
                                  smsCounselor: this.state.smsCounselor,
                                  smsStudent: this.state.smsStudent,
                                  emailStudent: this.state.emailStudent,
                                  aggrementSigned: true,
                                  visaUserId: this.state.visaUserId,
                                }).then(({ data, error, message }) => {
                                  dispatch(hideLoader());
                                  if (!error) {
                                    notification.success({
                                      message: message,
                                    });
                                    this.setFormValues(this.state.inquiryId);
                                    dispatch(
                                      getUrlPushWrapper("desk.application")
                                    );
                                  } else {
                                    notification.error({
                                      message: message,
                                    });
                                  }
                                });
                              } else {
                                notification.error({
                                  message: "Agreement must be signed.",
                                });
                              }
                            }}
                            loading={this.props.loading}
                          >
                            Process To Visa Desk
                            <Icon type="right" />
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              ) : null}
            </Row>

            {!course.length ? "No course choosen" : null}
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddApplication);
